import styled, { css } from 'styled-components';
import CheckIcon from 'mdi-react/CheckIcon';
import { colors } from '@prisjakt/ui-base';

export const SIZE = 20;

export const hoverStyle = css`
  box-shadow: inset 0 0 0 2px ${props => props.theme.bg.productCompare};
`;

type WrapperProps = {
  selected?: boolean;
};

export const Wrapper = styled.label<WrapperProps>`
  display: flex;
  align-items: center;
  align-self: center;
  background: ${props =>
    props.selected ? props.theme.bg.productCompare : 'transparent'};
  box-shadow: inset 0 0 0 1px ${props => props.theme.bg.productCompare};
  color: ${colors.white};
  border-radius: 3px;
  cursor: pointer;
  height: ${SIZE}px;
  width: ${SIZE}px;
  flex: 0 0 auto;
  transition: 0.05s box-shadow linear, 0.05s background-color linear;

  &:hover {
    ${hoverStyle}
  }
`;

export const Input = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  outline: 0;
  opacity: 0;
  position: absolute;
`;

export const Icon = styled(CheckIcon).attrs({ size: SIZE })``;
